import { BottomSheet, CbhIcon, Text, type UseModalState } from "@clipboard-health/ui-components";
import { alpha, Box, DialogContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import pluralize from "pluralize";

import { PRIORITY_ACCESS_COLOR } from "../../lib/Theme/constants";
import { Button } from "../components/Button";
import { DialogFooter } from "../components/DialogFooter";

interface ReactivationBonusBottomSheetProps {
  modalState: UseModalState;
  bonusAmountInDollars: number;
  requiredShiftCount: number;
  startDate: string;
  deadlineDate: string;
}

export function ReactivationBonusBottomSheet(props: ReactivationBonusBottomSheetProps) {
  const { modalState, bonusAmountInDollars, requiredShiftCount, startDate, deadlineDate } = props;

  const shiftText = `${requiredShiftCount} ${pluralize("shift", requiredShiftCount)}`;

  useLogEffect(
    APP_V2_USER_EVENTS.REACTIVATION_BONUS_BOTTOM_SHEET_VIEWED,
    {
      bonusAmountInDollars,
      requiredShiftCount,
      deadlineDate,
    },
    { enabled: modalState.modalIsOpen }
  );

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            variant="contained"
            size="small"
            sx={{
              width: "auto",
              alignSelf: "center",
            }}
            onClick={modalState.closeModal}
          >
            Got it
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Stack spacing={4} alignItems="center" sx={{ padding: 2 }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              backgroundColor: alpha(PRIORITY_ACCESS_COLOR, 0.1),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CbhIcon type="gift-lavender-colored" size="large" />
          </Box>

          <Text variant="h2" sx={{ textAlign: "center" }}>
            We missed you!
          </Text>

          <Text semibold variant="body1" sx={{ textAlign: "center" }}>
            {`Limited Offer: $${bonusAmountInDollars} Bonus`}
          </Text>

          <Text variant="body2" sx={{ textAlign: "center" }}>
            Earn <b>${bonusAmountInDollars}</b> when you <b>complete {shiftText}</b> between{" "}
            <b>
              {startDate} and {deadlineDate}
            </b>
            . Payout will hit your account within 24 hours of completing your {shiftText}.
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
